import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Fade, Flip } from '../../animation/animation';
import styles from './doctor.module.scss';
import defaultImage from './doctor.jpg';

import { Doctor as DoctorProps } from '../../models/doctor.model'
import { PopupWindowID } from '../../enums/popup-window-id.enum';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { InstructionPopup } from '../instruction-popup/instruction-popup';
import { displayPopupWindow, setActivePopupWindowId } from '../../reducers/quiz/quiz.actions';
import { WhatsappFormRound } from '../whatsApp-form/whatsapp-form-round';
import { FormType } from '../../enums/form-type.enum';

function Doctor({ active, name, surname, photo, patronymic, post, experience, patients, theme = 'default', whatsApp }: Partial<DoctorProps>) {
	const isWide = useMediaQuery({ minWidth: 501 });
	const lead_id = useSelector((state: RootState) => state.client?.lead?._id);
	const { activePopupWindowID, popupWindow } = useSelector((state: RootState) => state.quiz);
	const dispatch = useDispatch();
	const fromMobile: boolean = useMediaQuery({ maxWidth: 900 });

	const onClosePopup = () => {
		dispatch(displayPopupWindow(false));
	}

	const submitWhatsappForm = useCallback(async () => {
		setTimeout(() => {
			dispatch(setActivePopupWindowId(PopupWindowID.WHATSAPP_INSTRUCTIONS));
			dispatch(displayPopupWindow(true));
		}, 1000);
	}, [lead_id]);

	return (<>
		{(activePopupWindowID == PopupWindowID.WHATSAPP_INSTRUCTIONS && whatsApp) &&
			<InstructionPopup
				whatsappParams={{
					phone: whatsApp.doctor_phone || whatsApp.phone,
					text: whatsApp.doctor_text,
					form_type: FormType.DOCTOR_WHATSAPP,
					remove_lead_id: whatsApp.remove_lead_id_doctor,
				}}
				onClose={onClosePopup}
				active={popupWindow} />
		}
		<Fade up duration={400} when={active}>
			<div className={styles[theme]}>

				<Flip left delay={300} when={active}>
					<img className={styles.photo} src={name && surname && photo ? photo : defaultImage} alt="" />
				</Flip>

				{name && surname ?
					<>
						<h3 className={styles.name}>
							{`${surname} ${name}`}
							{(isWide && patronymic) && ` ${patronymic}`}
						</h3>

						<p className={styles.practice}>
							{post},&nbsp;
							{experience && `опыт ${experience}`}<br />
							{(isWide && patients) && patients}
						</p>
					</>
					:
					<>
						<h3 className={styles.name}>Расчет цены</h3>
						<p className={styles.practice}>
							{isWide ?
								<>Пройдите короткий тест и рассчитайте стоимость лечения</> :
								<>Пройдите тест и узнайте цену</>
							}
						</p>
					</>
				}

				{(fromMobile && whatsApp?.enable && whatsApp.inDoctorBlock) && <WhatsappFormRound
					onSubmit={submitWhatsappForm}
					whatsappParams={{
						phone: whatsApp.doctor_phone || whatsApp.phone,
						text: whatsApp.doctor_text,
						form_type: FormType.DOCTOR_WHATSAPP,
						remove_lead_id: whatsApp.remove_lead_id_doctor,
					}}
				/>}
			</div>
		</Fade>
	</>)
}

export default Doctor;